import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["blocks", "block", "templateInput", "customHoursSection"]

  removeBlock(event) {
    const block = event.target.closest("[data-availability-target='block']")
    if (block) {
      const container = block.parentElement
      const day = container?.dataset?.day
      block.remove()

      if (container && !container.querySelector("[data-availability-target='block']")) {
        const msg = document.createElement("p")
        msg.id = day ? `empty_${day}` : ""
        msg.className = "text-sm text-neutral-400 pt-1.5"
        msg.textContent = day === "override" ? "No time blocks. Add one below." : "Unavailable"
        container.appendChild(msg)
      }
    }
  }

  buildTemplate(event) {
    const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]
    const template = {}

    days.forEach(day => {
      const container = this.blocksTargets.find(el => el.dataset.day === day)
      if (!container) {
        template[day] = []
        return
      }

      const blocks = container.querySelectorAll("[data-availability-target='block']")
      template[day] = Array.from(blocks).map(block => {
        const inputs = block.querySelectorAll("input[type='hidden'][data-select-target='input']")
        return {
          start: inputs[0]?.value || "09:00",
          end: inputs[1]?.value || "17:00"
        }
      })
    })

    this.templateInputTarget.value = JSON.stringify(template)
  }

  toggleCustomHours(event) {
    if (!this.hasCustomHoursSectionTarget) return

    if (event.target.value === "custom") {
      this.customHoursSectionTarget.classList.remove("hidden")
    } else {
      this.customHoursSectionTarget.classList.add("hidden")
    }
  }
}
